import React, { useState } from "react";
import "../../styles/UserForm.css";
import axiosClient from "../../api/axiosClient";

function AddTenant({ onClose, onSuccess }) {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const [form, setForm] = useState({
    name: "",
    code: "",
    domain: "",
    contact_email: "",
    theme_color: "#007bff",
    logo_url: "",
  });

  const updateForm = (key, value) => {
    setError("");
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const validate = () => {
    if (!form.name.trim() || !form.code.trim()) {
      setError("Tenant name and code are required");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      setSaving(true);
      const res = await axiosClient.post("/tenant/api/create", form);

      if (res?.data?.success) {
        const createdTenant = res?.data?.tenant || res?.data?.data || null;
        const tenantId = createdTenant?.id;

        // ✅ Notify parent component
        onSuccess?.(createdTenant);

        // ✅ Open Role Permission Drawer immediately
        if (tenantId && typeof window.openTenantPermissionDrawer === "function") {
          window.openTenantPermissionDrawer(tenantId);
        }

        // ✅ Close Add Tenant drawer
        onClose?.();
      } else {
        setError(res?.data?.message || "Failed to create tenant");
      }
    } catch (err) {
      console.error("❌ Tenant creation failed:", err);
      setError("Failed to create tenant");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="uf-modal" onClick={onClose}>
      <div className="uf-card" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="uf-header">
          <h5 className="text-white">Add Tenant</h5>
          <button type="button" onClick={onClose}>✕</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="uf-body">
            {error && <div className="alert alert-danger py-2">{error}</div>}

            <div className="uf-grid">
              <div>
                <label className="form-label">Name *</label>
                <input
                  className="form-control"
                  value={form.name}
                  onChange={(e) => updateForm("name", e.target.value)}
                />
              </div>

              <div>
                <label className="form-label">Code *</label>
                <input
                  className="form-control"
                  value={form.code}
                  onChange={(e) => updateForm("code", e.target.value)}
                />
              </div>

              <div>
                <label className="form-label">Domain</label>
                <input
                  className="form-control"
                  value={form.domain}
                  onChange={(e) => updateForm("domain", e.target.value)}
                />
              </div>

              <div>
                <label className="form-label">Contact Email</label>
                <input
                  type="email"
                  className="form-control"
                  value={form.contact_email}
                  onChange={(e) => updateForm("contact_email", e.target.value)}
                />
              </div>

              <div>
                <label className="form-label">Theme Color</label>
                <input
                  type="color"
                  className="form-control form-control-color"
                  value={form.theme_color}
                  onChange={(e) => updateForm("theme_color", e.target.value)}
                />
              </div>

              <div>
                <label className="form-label">Logo URL</label>
                <input
                  className="form-control"
                  value={form.logo_url}
                  onChange={(e) => updateForm("logo_url", e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="uf-actions">
            <button type="button" className="btn btn-cancel" onClick={onClose}>
              Cancel
            </button>
            <button className="btn btn-primary" type="submit" disabled={saving}>
              {saving ? "Saving…" : "Save Tenant"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddTenant;
